import * as angular from "angular";

const taskTypes = ['Stopover', 'BundledStopover', 'Internal'];
const taskStates = ['StartableBest', 'Startable', 'StartedBest', 'Started', 'UnstartableDependent', 'UnstartableNoRoute', 'Impossible'];
const internalTaskTypes = ['StartRoute', 'EndRoute', 'StartDay', 'EndDay'];
const internalTaskDayTypes = ['StartDay', 'EndDay'];
const internalTaskRouteTypes = ['StartRoute', 'EndRoute'];
const typesToTitle = {
  Pickup: 'Pickup',
  Dropoff: 'Dropoff'
};
const typesToColor = {
  Pickup: 'orange-800',
  Dropoff: 'blue-600',
  Operation: 'green-600'
};
const purposeToColor = {
  Pickup: '#FF9936',
  Dropoff: '#2196F3',
  Operation: '#35C6AC',
  Start: '#616161',
  End: '#616161'
};
const purposeToBackgroundColor = {
  Pickup: '#FEF9F6',
  Dropoff: '#ECF8FE',
  Operation: '#F2FCFC',
  Start: '#e5e5e5',
  End: '#e5e5e5'
};
const generalTasksByAgentType = {
  DRIVER: ['StartDrive', 'EndDrive', 'StartDayDrive', 'EndDayDrive'],
  SERVICE_AGENT: ['StartMerch', 'EndMerch', 'StartDayMerch', 'EndDayMerch']
};
const actionableStatuses = [
  'CourierHeading',
  'Assigned',
  'CourierArrived',
  'ContactNotAvailable'
];
const statusTitle = {
  Completed: 'Completed',
  Unassigned: 'Unassigned',
  CourierDeparted: 'Completed',
  CourierHeading: 'Heading',
  Assigned: 'Assigned',
  CourierArrived: 'Arrived',
  Canceled: 'Canceled',
  ContactNotAvailable: 'Contact N/A'
};
const status = {
  CourierDeparted: 'CourierDeparted',
  Completed: 'Completed',
  CourierHeading: 'CourierHeading',
  Assigned: 'Assigned',
  CourierArrived: 'CourierArrived',
  Canceled: 'Canceled',
  ContactNotAvailable: 'ContactNotAvailable'
};
const statusToBackground = {
  Unassigned: 'blue-grey-200',
  Assigned: 'blue-500',
  CourierHeading: 'light-blue-800',
  CourierArrived: 'light-blue-800',
  Canceled: 'red-300',
  ContactNotAvailable: 'red-500',
  CourierDeparted: 'green-300',
  Completed: 'green-400'
};
const statusToColor = {
  Unassigned: '#A6AFB1',
  Assigned: '#0BBBE6',
  CourierHeading: '#50A4BE',
  CourierApproaching: '#50A4BE',
  CourierArrived: '#50BEB7',
  Canceled: '#910000',
  ContactNotAvailable: '#D52424',
  CourierDeparted: '#3FA300',
  Completed: '#65BF57',
  ManualHandled: '#318B31',
  Default: '#c6c6c6'
};
const slaIndexToColor = {
  1: '#F8522D',
  2: '#F8A72D',
  3: '#F4CD27',
  4: '#65BF57'
};
const purposes = {
  pickup: 'Pickup',
  dropoff: 'Dropoff'
};
const purposeToServiceType = {
  Pickup: 'Delivery',
  Dropoff: 'Delivery',
  Operation: 'Operation'
};
const uneditablePODs = {
  validateAge: true,
};
const relationTypes = ['Blocking', 'BlockedBy', 'References', 'ReferencedBy'];

angular
  .module('bringoz.admin.tasks')
  .constant('tasksConstants', {
    taskTypes: taskTypes,
    taskStates: taskStates,
    internalTaskTypes: internalTaskTypes,
    internalTaskDayTypes: internalTaskDayTypes,
    internalTaskRouteTypes: internalTaskRouteTypes,
    typesToTitle: typesToTitle,
    typesToColor: typesToColor,
    purposeToColor: purposeToColor,
    purposeToBackgroundColor: purposeToBackgroundColor,
    generalTasksByAgentType: generalTasksByAgentType,
    actionableStatuses: actionableStatuses,
    statusTitle: statusTitle,
    status: status,
    statusToBackground: statusToBackground,
    statusToColor: statusToColor,
    slaIndexToColor: slaIndexToColor,
    purposes: purposes,
    purposeToServiceType: purposeToServiceType,
    relationTypes: relationTypes,
    uneditablePODs: uneditablePODs
  });
